import React from "react";
import { Form } from "react-bootstrap";

const Checklist = (props) => {
  return (
    <div style={{ padding: "3px 0px", borderRadius: "5px", border: "1px solid #CED4DA" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "10px",
          maxHeight: props.maxHeight || "175px",
          overflowY: "auto",
        }}
      >
        {props.checkboxes &&
          props.checkboxes.map((checkbox, index) => (
            <div
              style={{
                display: "flex",
                gap: "10px",
                borderBottom: index !== props.checkboxes.length - 1 ? "1px solid #CED4DA" : "",
                paddingBottom: index !== props.checkboxes.length - 1 ? "10px" : "0px",
              }}
            >
              <Form.Check onClick={checkbox.onClick} checked={checkbox.checked} />
              {checkbox.label}
            </div>
          ))}
      </div>
    </div>
  );
};

export default Checklist;
